import { Routes, Route } from "react-router-dom";
import "./App.css";
import Layout from "./layout/Layout";

import DashBoard from "./pages/dasboard";
import LoginPage from "./pages/login";
import OverView from "./pages/overview";
import BroadcastPage from "./pages/broadcast";
import ViewerPage from "./pages/viewer";
import { IntlProvider } from "react-intl";
import localeMessages from "./locale/messages";
import { useSelector } from "react-redux";
import { SSEProvider } from "./hooks/SSEContext";

function App() {
  const locale = useSelector((state) => state.users.locale);

  return (
    <IntlProvider
      messages={localeMessages[locale]}
      locale="en"
      defaultLocale="en"
    >
      <SSEProvider>
        <div className="App">
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<LoginPage />} />
              <Route path=":id" element={<DashBoard />} />
              <Route path="*" element={<div>not found</div>} />
              <Route path="over-view/:tableId" element={<OverView />} />
            </Route>
            {/* Streaming routes - outside Layout for full-screen */}
            <Route path="stream/broadcast/:roomId" element={<BroadcastPage />} />
            <Route path="stream/view/:roomId" element={<ViewerPage />} />
          </Routes>
        </div>
      </SSEProvider>
    </IntlProvider>
  );
}

export default App;
